
import React, { useState } from 'react';
import { MemberModel, SiteSettingModel, BranchModel } from '../../../models';
import PublicRegistration from '../../home/studentRegistration';
import StudentDashboard from './StudentRoot';
import { db } from '../../../firebase';
import { doc, setDoc } from 'firebase/firestore';

interface StudentEntryProps {
    member: MemberModel;
    siteSettings: SiteSettingModel;
    branches: BranchModel[];
    onGoHome?: () => void;
}

const StudentEntry: React.FC<StudentEntryProps> = ({ member, siteSettings, branches, onGoHome }) => {
    console.log('Rendering StudentEntry', member?.id);
    // Check if profile is complete
    const isProfileComplete = !!(member.schoolName && member.grade);

    // State to force re-render/update
    const [profile, setProfile] = useState(member);
    const [isComplete, setIsComplete] = useState(isProfileComplete);

    const handleRegistrationSubmit = async (updatedMember: MemberModel) => {
        try {
            await setDoc(doc(db, 'members', member.id), updatedMember, { merge: true });
            setProfile(updatedMember);
            setIsComplete(true);
        } catch (e) {
            console.error(e);
            alert('정보 저장 실패');
        }
    };

    if (!isComplete) {
        return (
            <PublicRegistration
                onBack={() => { window.location.reload(); }}
                onSubmit={handleRegistrationSubmit}
                branches={branches}
                siteSettings={siteSettings}
                initialEmail={member.email}
                initialName={member.name}
            />
        );
    }

    // Render the Actual Student Dashboard
    return (
        <StudentDashboard
            member={profile}
            siteSettings={siteSettings}
            branches={branches}
            onGoHome={onGoHome}
        />
    );
};

export default StudentEntry;
